// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Up-z","imageAndVideoCount":"Vp-z","imageAndVideoContainer":"Wp-z","viewAllReviews":"Xp-z"};